<div class="mydocma-dialog-container mydocma-mm-pool-edit-dialog-container" [class.mobile-view]="appContainerService.isMobileView">
    <div class="mydocma-dialog-header">
        <div class="mydomca-dialog-header-title">
            {{title$ | async}}
        </div>
        <div>
            <button mat-icon-button type="button" (click)="onCancel()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <div class="mydocma-dialog-body">
        <mydocma-loader [size]="'small'" class="mydocma-mm-loader"
            *ngIf="(loading$ | async) || saving"></mydocma-loader>

        <div class="pool-edit-dialog-content">
            <div class="pool-edit-form-container">
                <mydocma-dynamic-form [formConfig]="formConfig" (ready)="onFormReady($event)">
                </mydocma-dynamic-form>
            </div>
        </div>
    </div>

    <div class="mydocma-dialog-footer">
        <div style="margin-right: 10px">
            <button mat-stroked-button class="mydocma-btn" (click)="onCancel()">
                {{'MM.general.button.cancel' | translate}}
            </button>
        </div>
        <div>
            <button mat-stroked-button class="mydocma-btn-primary" (click)="onSaveChanges()"
                [disabled]="!(hasChanges$ | async) || (hasErrors$ | async) || saving">
                {{'MM.general.button.save' | translate}}
            </button>
        </div>
    </div>


</div>
